
import api from '../../api/extraInformationForRide';
import { router } from '../../main';

const state = {
  extraInformationForRideEditedTitle: null,
  extraInformationForRideEditedContent: null,
  extraInformationForRideEditedId: null,
  extraInformationForRideRideId: null,
  extraInformationForRideDate: null,
};

const getters = {
  extraInformationForRideEditedTitle: state => state.extraInformationForRideEditedTitle,
  extraInformationForRideEditedContent: state => state.extraInformationForRideEditedContent,
  extraInformationForRideEditedId: state => state.extraInformationForRideEditedId,  
  extraInformationForRideDate: state => state.extraInformationForRideDate,
  extraInformationForRideIsDayInformation: state => state.extraInformationForRideDate !== null,
};

const actions = {
  extraInformationForRideLoadDefault({ commit }) {
    commit('setExtraInformationForRideEditedTitle', null);
    commit('setExtraInformationForRideEditedContent', null);
    commit('setExtraInformationForRideEditedId', null);
    commit('setExtraInformationForRideRideId', null);
    commit('setExtraInformationForRideDate', null);   
  },

  async openExtraInformationForRide({ getters, commit }, locatedDay=null ) {
    const rideId = getters.allRide.ride.id;
    commit('setExtraInformationForRideRideId', rideId )
    commit('setExtraInformationForRideDate', locatedDay )
    router.push('/ride_extra_information/' + rideId ) ;
  },

  async addExtraInformationForRide({ state, rootState, dispatch }) {
    var extraInformationForRide = {}
    extraInformationForRide['title'] = state.extraInformationForRideEditedTitle;
    extraInformationForRide['text'] = state.extraInformationForRideEditedContent;
    extraInformationForRide['ride_id'] = state.extraInformationForRideRideId;
    extraInformationForRide['date'] = state.extraInformationForRideDate;

    const { apptoken } = rootState.appauth;
    const response = await api.addExtraInformationForRide(apptoken,
      extraInformationForRide);
    if (response.status === 200) {
      const rideId = state.extraInformationForRideRideId
      await dispatch('extraInformationForRideLoadDefault');    // set the ride id to lowad
      router.push('/single_ride_with_map/' + rideId);
    }
  },
  
  async editExtraInformationForRide({ getters, commit }, { rideId, extraInformationId }) {
    let extraInformationForEditing = null;
    const rideHeader = getters.rideHeader
    const combinedExtraInformation = [
      ...(rideHeader.ride.rideExtraInformation || []),
      ...(rideHeader.ride.rideExtraInformationByDay || [])
    ];
    for (const extraInformation of combinedExtraInformation) {
      if (extraInformation.id === extraInformationId) {
        extraInformationForEditing = extraInformation;
        break;
      }
    }
    if (!extraInformationForEditing) {
      return;
    }
  
    commit('setExtraInformationForRideEditedTitle', extraInformationForEditing.title);
    commit('setExtraInformationForRideEditedContent', extraInformationForEditing.text);
    commit('setExtraInformationForRideEditedId', extraInformationId);
    commit('setExtraInformationForRideRideId', rideId);
    router.push('/ride_extra_information/' + rideId);
  },

  async updateExtraInformationForRide({ state, rootState, dispatch }) {
    var extraInformationForRide = {}
    extraInformationForRide['title'] = state.extraInformationForRideEditedTitle;
    extraInformationForRide['text'] = state.extraInformationForRideEditedContent;
    extraInformationForRide['extra_information_id'] = state.extraInformationForRideEditedId;
    extraInformationForRide['ride_id'] = state.extraInformationForRideRideId;

    const { apptoken } = rootState.appauth;
    const response = await api.updateExtraInformationForRide( apptoken,
                                                              extraInformationForRide);
    
    if( response.data.ServerMassageCode != "success" ){
      dispatch( 'showModalWithParameters',
      { errorNumber : response.data.ServerMassageCode,
        type:'textConverter' 
      } );
      return
    }
    const rideId = state.extraInformationForRideRideId
    await dispatch('extraInformationForRideLoadDefault');    // set the ride id to lowad
    router.push('/single_ride_with_map/' + rideId);
  },

  async deleteExtraInformationForRide({ state, rootState, dispatch }) {
    var extraInformationForRide = {}
    extraInformationForRide['extra_information_id'] = state.extraInformationForRideEditedId;
    extraInformationForRide['ride_id'] = state.extraInformationForRideRideId;

    const { apptoken } = rootState.appauth;
    const response = await api.deleteExtraInformationForRide( apptoken,
                                                              extraInformationForRide);
    
    if( response.data.ServerMassageCode != "success" ){
      dispatch( 'showModalWithParameters',
      { errorNumber : response.data.ServerMassageCode,
        type:'textConverter' 
      } );
      return
    }
    const rideId = state.extraInformationForRideRideId
    await dispatch('extraInformationForRideLoadDefault');    // set the ride id to lowad
    router.push('/single_ride_with_map/' + rideId);
  },

};

const mutations = {
  setExtraInformationForRideEditedTitle: (state, extraInformationForRideEditedTitle ) => {
    state.extraInformationForRideEditedTitle = extraInformationForRideEditedTitle;
  },
  setExtraInformationForRideEditedContent: (state, extraInformationForRideEditedContent ) => {
    state.extraInformationForRideEditedContent = extraInformationForRideEditedContent;
  },
  setExtraInformationForRideEditedId: (state, extraInformationForRideEditedId ) => {
    state.extraInformationForRideEditedId = extraInformationForRideEditedId;
  },
  setExtraInformationForRideRideId: (state, extraInformationForRideRideId ) => {
    state.extraInformationForRideRideId = extraInformationForRideRideId;
  },
  setExtraInformationForRideDate: (state, extraInformationForRideDate ) => {
    state.extraInformationForRideDate = extraInformationForRideDate;
  },
  
};

export default {
  state,
  getters,
  actions,
  mutations
};
